import { navLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-50 border-t border-secondary-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg leading-none">
                茄
              </span>
              <span className="font-heading text-lg text-foreground-950">茄子视频</span>
            </div>
            <p className="mt-4 text-xs text-foreground-600 leading-relaxed max-w-sm">
              一个专注下载指引的内容页面：官方入口、最新地址、APP 安装教程与常见问题，
              信息会随线路更新同步维护。
            </p>
          </div>

          <div>
            <h3 className="text-xs tracking-widest text-foreground-500 uppercase">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-700 hover:text-primary-700 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs tracking-widest text-foreground-500 uppercase">温馨提示</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-secondary-700"></i>
                <span>地址有变动会及时更新</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-bookmark-line mt-0.5 text-secondary-700"></i>
                <span>建议收藏本页方便回访</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-secondary-700"></i>
                <span>只从官方入口下载更稳妥</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 茄子视频下载指引 · 本页仅为信息整理与导航说明</p>
          <a href="#top" className="text-xs text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap">
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}